module.exports = __webpack_public_path__ + "assets/c522c0371a9b5bb4b08d7e1b9cebfa81.png";